import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../../services/apiService"; // Importar la función de login
import { useUser } from "../../contexts/user-context"; // Importar el contexto de usuario
import Input from "../../components/ui/input";
import Button from "../../components/ui/button";
import styles from "./login.module.css";
import usePageTitle from "../../hooks/usePageTitle";

const LoginPage = () => {
  usePageTitle('Iniciar Sesión');
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login: loginUser } = useUser();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const data = await login({ username, password });
      console.log("Datos de login:", data); 
      
      // Guardar en localStorage
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("userRole", data?.role);
      localStorage.setItem("usuarioId", data?.usuarioId);
      localStorage.setItem("username", data?.username || username);
      localStorage.setItem("userName", data?.nombre || data?.name || username);
      localStorage.setItem("isAuthenticated", "true"); 

      // Actualizar el contexto de usuario
      loginUser(data);

      console.log("Token guardado:", localStorage.getItem("authToken"));
      console.log("Rol guardado:", localStorage.getItem("userRole"));
      console.log("Usuario ID guardado:", localStorage.getItem("usuarioId"));

      switch (data?.role) {
        case "ROLE_OPERARIO":
          console.log("Usuario worker");
          navigate("/appointments");
          break;
        case "ROLE_ADMIN":
          console.log("Usuario superuser");
          navigate("/dashboard");
          break;
        case "ROLE_USER":
        default:
          console.log("Usuario administrative");
          navigate("/alarms");
      }
    } catch (err) {
      console.error("Error en login:", err);
      setError("Credenciales incorrectas. Inténtalo de nuevo.");
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.logoContainer}>
        <img
          src={`${process.env.PUBLIC_URL}/logo_ager_completo.png`}
          alt="Ager"
          className={styles.logoFull}
        />
      </div>
      <form onSubmit={handleLogin} className={styles.formContainer}>
        <h1 className={styles.title}>Iniciar sesión</h1>
        
        {error && <p className={styles.error}>{error}</p>}

        <Input
          label="Usuario"
          name="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Nombre de usuario"
          style={{ width: "300px" }}
        />
        <Input
          label="Contraseña"
          name="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Contraseña"
          style={{ width: "300px" }}
        />

        <Button type="submit">INGRESAR</Button>
      </form>
    </div>
  );
};

export default LoginPage;
